import SoundManager from './soundManager.js';

class KeyboardManager {
    
    constructor() {
        this._stack = [];
        this._listeners = [];
        this._bindings = {};
        this._updateBindings();
        window.addEventListener('keydown', this.onKeyPress);
    }
    
    onKeyPress = (event) => {
        let name = event.key.toUpperCase();
        
        console.log(name)
        
        if( name === 'ENTER' ) {    
	        SoundManager.play('key1');
        } else if( name === 'ESCAPE' ) {    
	        SoundManager.play('key2');
        } else if( 'SHIFT ALT CONTROL META'.indexOf(name.toUpperCase()) === -1 ) {
	        SoundManager.play('key3');
        }
        
        
        if(name.indexOf('ARROW') === 0) name = name.slice(5);
        if(name === 'ESCAPE') name = 'ESC';
        if(event.altKey && event.code.indexOf('Key') === 0) name = 'ALT-'+event.code.slice(3);
        if(event.key === '?') name = '?';
        if(this._bindings[name]) {
            if(this._bindings[name].handler)
                this._bindings[name].handler(name);
            event.preventDefault();
        }
    }
    
    pushView(view) {
        this._stack.push(view);
        this._updateBindings();
    }
    
    popView(view) {
        let idx = this._stack.indexOf(view);
        if(idx < 0) return;
        this._stack.splice(idx,1);
        this._updateBindings();
    }
    
    addListener(listener) {
        this._listeners.push(listener);
    }
    
    removeListener(listener) {
        let idx = this._listeners.indexOf(listener);
        this._listeners.splice(idx, 1);
    }
    
    getBindings() {
        return this._bindings;
    }
    
    _updateBindings() {
        let result = {};
        this._stack.map(frame => frame.getKeyboardListeners()).forEach(frame => {
            Object.assign(result, frame);
        });
        this._bindings = result;
        
        this._listeners.forEach(ln => ln(result));
    }
}

export default new KeyboardManager();
